<template>
  <div class="file-import">
    <!-- 上传，限制张数 -->
    <el-upload ref="file-import"
               multiple
               :default-file-list="defaultList"
               :on-success="handleSuccess"
               :on-remove="handleRemove"
               :format="format"
               :max-size="102400"
               :on-format-error="handleFormatError"
               :on-exceeded-size="handleMaxSize"
               :before-upload="handleBeforeUpload"
               name="imgFile"
               :data="postData"
               :headers="headData"
               :action="actionUrl">
      <el-button size="small"
                 type="primary">选择文件</el-button>
    </el-upload>
  </div>
</template>
    
    <script>
export default {
  name: "FileImport",
  data () {
    return {
      // 已经上传成功的所有文件结果
      videoList: [],
      resList: [],
      actionUrl: process.env.VUE_APP_BASE_API + "/common/upload/excel",
      headData: {
        Authorization: this.$store.getters.token
      },
      postData: {
        thumb: 0,
        thumbWidth: "200px",
        thumbWidth: "200px"
      }
    };
  },
  props: {
    alterString: {
      type: String,
      default: function () {
        return "请严格按照模板填写内容，上传！";
      }
    },
    defaultList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    format: {
      type: Array,
      default: function () {
        return ["mp4", "mp3", "doc", "docx", "xls", "xlsx", "pdf", "pem",];
      }
    }
  },
  mounted () {
    this.resList = this.$refs["file-import"].fileList;
  },
  watch: {
    defaultList (curVal, oldVal) {
      if (curVal) {
        this.resList = curVal;
      }
    }
  },
  created: function () { },
  methods: {
    handleClearFiles () {
      // 再次点击上传之前，清空之前已上传文件
      this.$refs["file-import"].clearFiles();
    },
    // 移除的回调
    handleRemove (file) {
      this.resList = this.$refs["file-import"].fileList;
    },
    // 上传成功的回调
    handleSuccess (res, file) {
      // console.log(res)
      if (res.code == 200) {
        this.$message.success({
          type: "success",
          message: "导入成功"
        });
        this.resList.push({
          name: res.result.orifilename,
          filetype: res.result.filetype,
          url: res.result.url,
        });
      } else {
        this.$message.warning({
          type: "error",
          message: res.msg
        });
      }
    },
    // 检查文件格式
    handleFormatError (file) {
      this.$message.warning({
        type: "error",
        message:
          "文件 " + file.name + " 格式不正确, 请插入doc,docx,xls,xlsx,pdf,mp3。"
      });
    },
    // 检查大小
    handleMaxSize (file) {
      this.$message.warning({
        type: "error",
        message: "文件 " + file.name + " 太大，最大就不要超过100M！"
      });
    },
    // 上传前检查数量
    handleBeforeUpload () {
      const check = this.resList.length < 10;
      if (!check) {
        this.$message.warning({
          type: "error",
          message: "已经超出最大可上传数量！"

        });
      }
      return check;
    }
  }
};
    </script>
    
    